import { render, staticRenderFns } from "./ActionFooter.vue?vue&type=template&id=dcb37f48&scoped=true&"
import script from "./ActionFooter.vue?vue&type=script&lang=js&"
export * from "./ActionFooter.vue?vue&type=script&lang=js&"
import style0 from "./ActionFooter.vue?vue&type=style&index=0&id=dcb37f48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb37f48",
  null
  
)

export default component.exports